export default "__VITE_ASSET__NEp$b7T___"